import * as Sentry from '@sentry/react';
import { Environment } from '@src/environment.ts';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import { filterEvent } from '@funnellab/shared/src/errorHandling/errorFilter';
import { errorFilters } from './errorFilters';

if (Environment.isProd || Environment.isDev) {
  Sentry.init({
    environment: Environment.ENV,
    dsn: 'https://dd02be9795eee31b521f0b2c004a5994@o4508410240630784.ingest.de.sentry.io/4508410376683600',
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
      return filterEvent(errorFilters, event);
    },
  });
}
